'use strict';

var EditNat = require('actionGroups/onemanyNat/Nat');

module.exports = {
  Model: EditNat,
};
